
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        left: {
            type: Boolean,
            default: false,
        },
    },
})
